var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16.681 15.605"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.637 12.631c-.339 3.044-3.98 3.384-6.309 2.639A17 17 0 011.95 8.896a9.407 9.407 0 01-1.9-3.892C-.309 3.253 1.128-1.128 3.726.272a1.941 1.941 0 01.371.43c.47 1.173.959 2.268 1.428 3.363a.941.941 0 01-.058.724A6.837 6.837 0 014.45 6.138a.614.614 0 00-.1.9 11.018 11.018 0 005.632 4.85.638.638 0 00.841-.2c.43-.489.841-1.036 1.232-1.545a.689.689 0 01.919-.215c.821.352 1.6.724 2.386 1.076.215.117.371.195.547.293.828.395.828.454.73 1.334z",
    fill: "#4a4a4a",
    fillRule: "evenodd"
  })));
}
export default __webpack_public_path__ + "3ba4c8b3b6b86af8d322e153e47931e7.svg";
export { SvgPhoneIcon as ReactComponent };